/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import React from 'react';
import { Grid } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import SideBar from './SideBar';
import { BrowserView, MobileView } from 'react-device-detect';

const styles = makeStyles((theme) => ({
  root: {
    position: "relative",
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%,  ${theme.palette.secondary.main}  35%, ${theme.palette.primary.main}  100%)!important`,

    color: "black",


  },

  appBar: {
    width: '100%',
    borderBottom: `1px solid grey`

  },
  toolbar: {
    flexWrap: 'wrap'
  },
  toolbarTitle: {
    color: 'white',
    flexGrow: 1
  },
  headerMenu: {
    marginLeft: "auto",
    display: "inline-block",
    textAlign: "right",
    marginTop: "10px",
    "&:hover": {
      color: theme.palette.primary.main
    }
  },
  linkBar: {
    marginLeft: "30px",
    textAlign: "right",
    marginRight: "30px",
    paddingTop: "30px"
  },
}));


const PageHeader = () => {
  const classes = styles();
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

  };
  return (
    <div className={classes.root}>

      <Grid container >

        <AppBar
          position="static"
          elevation={0}
          className={classes.appBar}
        >
          <Toolbar className={classes.toolbar}>
            <Link
              to={"/"}
            >
              <img src="/assets/images/Logo/logo_transparent.png" alt="" height="80px" />
            </Link>

            <div className={classes.headerMenu}>
              <BrowserView>
                <Link to={"/"} className={classes.linkBar}
                ><Typography variant="h3" className={classes.headerMenu}>Home</Typography></Link>

                <Link to={"/services"} className={classes.linkBar}
                ><Typography variant="h3" className={classes.headerMenu}>Services</Typography></Link>
                <Link to={"/contact-us"} className={classes.linkBar}
                ><Typography variant="h3" className={classes.headerMenu}>Contact Us</Typography></Link>
                <Link to={"/about-us"} className={classes.linkBar}
                > <Typography variant="h3" className={classes.headerMenu} align="right">About Us</Typography></Link>
              </BrowserView>
              <MobileView>
                <SideBar />
              </MobileView>
            </div>
          </Toolbar>
        </AppBar>
      </Grid>
    </div>
  );

}


export default PageHeader;
